import { render, staticRenderFns } from "./MenuLeitfaden.vue?vue&type=template&id=202a5bb2&scoped=true&"
import script from "./MenuLeitfaden.vue?vue&type=script&lang=js&"
export * from "./MenuLeitfaden.vue?vue&type=script&lang=js&"
import style0 from "./MenuLeitfaden.vue?vue&type=style&index=0&id=202a5bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a5bb2",
  null
  
)

export default component.exports